module.exports = __webpack_public_path__ + "static/N2N9s-15f9086bc4de4e72ac48a157198887e3.jpg";